import React, {ReactNode} from "react";
import IconStar from "@Icons/searchRes/IconStar";
import {Colors} from "@Styles/Colors.style";
import Row from "@Containers/components/Row";

type FeaturedRouteWrapperProps = {
    children: ReactNode
}

function FeaturedRouteWrapper(props: FeaturedRouteWrapperProps) {
    return (
        <div className="featured-route__wrapper">
            <Row center className="featured-route__title">
                <IconStar
                    fill={Colors.primaryColor}
                    stroke={Colors.primaryColor}
                    width="20"
                    height="20"
                />
                <span>
                    Popular departure
                </span>
            </Row>
            {props.children}
        </div>
    );
}

export default FeaturedRouteWrapper;